<template>
  <div class="catalog-resource-wrap">
    <el-alert type="info" :closable="false" show-icon class="library-link-bar">
      <template #title>公开资料库链接</template>
      <span class="library-url-text">{{ libraryPageUrl }}</span>
      <el-button size="small" type="primary" @click="copyLibraryUrl">复制链接</el-button>
      <el-button size="small" @click="openLibraryPage">新窗口打开资料库</el-button>
    </el-alert>
  <div style="display: flex;flex-direction: row;">
    <div style="width: 30%;">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>目录预览</span>
          <el-button style="float: right; padding: 3px 0" type="text" @click="getTree()">刷新目录树</el-button>
        </div>

        <el-tree :data="treeData" node-key="id" default-expand-all :expand-on-click-node="false">
          <template #default="{ node, data }">
            <span class="custom-tree-node" @click="findResource(data)">
              <span>{{ node.label }}</span>
            </span>
          </template>
        </el-tree>
      </el-card>

    </div>
    <div style="width: 70%;">
      <div>
        <el-input v-model="searchContent" size="mini" placeholder="输入关键字搜索" style="width: 200px;" />
        <el-button type="primary" :icon="Search" @click="getSearch()">搜索</el-button>
      </div>
      <el-scrollbar max-height="800px">
        <el-table v-loading="loading" :data="tableData" style="width: 100%">
          <!-- <el-table-column fixed prop="id" label="资源id"  width="150" /> -->
          <el-table-column prop="title" label="资源标题" width="120" />
          <el-table-column prop="content" label="资源描述" width="500" />
          <el-table-column prop="remarks" label="备注" width="120" />
          <el-table-column fixed="right" label="操作" width="120">
            <template v-slot="scope">
              <el-button link type="primary" size="small" @click="handleDetailShow(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>
      <el-pagination background layout="prev, pager, next" :page-size="pageSize" :current-page="currentPage"
        :total="totalCount" @current-change="handleCurrentChange" style="margin: 10px 0 ;" />
    </div>
  </div>
  <el-dialog title="资源详情" v-model="resourceDetailShow" width="80%">

    <div style="display: flex;flex-direction: row;width:100%">
      <el-scrollbar max-height="600px" style="width:50%">
        <div v-html="contentHtml"></div>
      </el-scrollbar>
      <el-scrollbar max-height="600px" style="width:50%">
        <el-text class="mx-1" resourceFile="primary">资源文件数量：{{ resourceFile.length }}</el-text>
        <el-table :data="formattedItems" style="width: 100%">
          <el-table-column prop="fileName" label="文件名称" width="120" />
          <el-table-column prop="content" label="文件内容" width="120" />
          <el-table-column prop="fileExtension" label="文件后缀" width="120" />
          <el-table-column prop="fileSize" label="文件大小" width="120" />
          <el-table-column prop="fileType" label="文件类型" width="120" />
          <el-table-column prop="time" label="创建时间" width="120" />
          <el-table-column prop="fileSrc" fixed="right" label="图片" width="120">
            <template v-slot="scope">
              <el-image v-if="scope && scope.row" style="width: 100px; height: 100px" :src="scope.row.fileUrl" />
              <span v-else>无图片</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template v-slot="scope">
              <el-button link type="primary" size="small" @click="">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>
    </div>
  </el-dialog>
  </div>
</template>

<script>
import { ElTree, ElButton, ElMessage, ElLoading } from 'element-plus';
const axios = require("axios");
import { inject } from 'vue'
import { buildLibraryPageUrl } from '@/utils/libraryUrl'

export default {
  components: {
    ElTree,
    ElButton,
  },
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      searchContent: "",
      searchCatalogId: '0',
      loading: true,
      serverUrl: inject('serverUrl'),
      fileUrl: inject('fileUrl'),
      treeData: [],
      tableData: [],
      resourceDetailShow: false,
      contentHtml: '',
      resourceFile: [],
      libraryPageUrl: buildLibraryPageUrl()
    }
  },
  computed: {
    formattedItems() {
      return this.resourceFile.map(item => ({
        ...item, // 保留其他属性
        time: (item.writetime.year + 1900) + "-" + (item.writetime.month + 1) + "-" + item.writetime.date + " " + item.writetime.hours + ":" + item.writetime.minutes + ":" + item.writetime.seconds, // 格式化时间
        fileUrl: this.fileUrl + item.fileSrc
      }));
    },
  },
  mounted() {
    this.getTree()

  },
  methods: {
    /** 复制公开资料库链接 */
    copyLibraryUrl() {
      navigator.clipboard.writeText(this.libraryPageUrl).then(() => {
        ElMessage.success('已复制资料库链接')
      }).catch(() => {
        ElMessage.error('复制失败')
      })
    },
    /** 新窗口打开公开资料库 */
    openLibraryPage() {
      window.open(this.libraryPageUrl, '_blank')
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getResource(this.searchCatalogId, this.searchContent);
    },
    async handleDetailShow(e) {
      this.resourceDetailShow = true;
      const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      console.log(e);

      const res = await axios.post(
        this.serverUrl + "/api/resource/detail", // 请求后端的 URL
        {
          "resourceId": e.id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=utf-8",
            "Access-Control-Allow-Origin": "*", // 允许所有域名访问，或者设置为特定的域名
            "Access-Control-Allow-Methods": "GET, POST, OPTIONS", // 允许的请求方法
            "Access-Control-Allow-Headers": "Content-Type", // 允许的请求头
          },
        }
      );
      console.log(res);
      console.log(res.data.obj.toolsResource.content);
      this.contentHtml = res.data.obj.toolsResource.content;
      this.resourceFile = res.data.obj.toolsFiles
      loading.close()
    },
    handleUpdate(row) {
      return "/updateproduct/" + row.id;
    },
    getSearch() {
      this.getResource(this.searchCatalogId, this.searchContent);
    },
    findResource(e) {
      console.log(e);
      this.searchCatalogId = e.id;
      this.getResource(e.id, this.searchContent);
    },
    async getTree() {
      const res = await axios.post(
        this.serverUrl + "/api/catalog/public/tree", // 请求后端的 URL
        null,
        {
          headers: {
            "Content-Type": "application/json;charset=utf-8",
            "Access-Control-Allow-Origin": "*", // 允许所有域名访问，或者设置为特定的域名
            "Access-Control-Allow-Methods": "GET, POST, OPTIONS", // 允许的请求方法
            "Access-Control-Allow-Headers": "Content-Type", // 允许的请求头
          },
        }
      );
      console.log('目录树', res);
      if (res.data.code == "success") {
        ElMessage({
          type: 'success',
          message: '目录树获取成功',
        })

        this.treeData = res.data.obj;

        this.getResource(this.searchCatalogId, this.searchContent);
      } else {
        ElMessage({
          type: 'error',
          message: '目录树获取失败',
        })
      }
    },

    async getResource(catalogId, content) {
      var that = this;
      this.loading = true;
      const res = await axios.post(
        this.serverUrl + "/api/resource/public/catalogget/list", // 请求后端的 URL
        {
          "catalogId": catalogId,
          "content": content,
          "limit": that.pageSize,
          "offset": (that.currentPage - 1) * that.pageSize
        },
        {
          headers: {
            "Content-Type": "application/json;charset=utf-8",
            "Access-Control-Allow-Origin": "*", // 允许所有域名访问，或者设置为特定的域名
            "Access-Control-Allow-Methods": "GET, POST, OPTIONS", // 允许的请求方法
            "Access-Control-Allow-Headers": "Content-Type", // 允许的请求头
          },
        }
      );
      console.log(res);
      that.tableData = res.data.obj.toolsResources;
      that.totalCount = res.data.obj.resourceCount;
      that.loading = false;
    },
  }

}
</script>

<style>
.catalog-resource-wrap {
  padding: 0 8px 8px;
}

.library-link-bar {
  margin-bottom: 12px;
}

.library-url-text {
  display: inline-block;
  margin-right: 12px;
  font-size: 13px;
  color: #475569;
  word-break: break-all;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>